import * as React from "react";
import * as jQuery from "jquery/dist/jquery";
import * as Bootstrap from "bootstrap/dist/js/bootstrap";
import { useEffect, useReducer, useRef, useState } from 'react';
import { Spinner, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from 'reactstrap';
import InfiniteScroll from 'react-infinite-scroller';
import * as Models from '../models';
import { UsedListingService, SearchIn } from '../services/usedListingService';
import classnames from 'classnames';
import { bool } from "prop-types";

const PAGE_SIZE = 10;

type Props = {
    buildingTypes: Models.LookupItem[];
    locations: Models.LookupItem[];
    culture: string;
}

type UsedListingPageState = {
    //searchBy: SearchType;
    keywords: string;
    buildingType: Models.LookupItem;
    location: Models.LookupItem;
    areaMin: number,
    areaMax: number,
    hasRestrooms: boolean,
    canLoadMore: boolean;
    isLoading: boolean;
    items: Models.UsedItem[];
    totalItems: number;
    lastFilter: SearchIn
    searchTrigger: number;
    currentView: string;
    sortByField: Models.LookupItem;
    isLocationMissing: boolean;
    hasFeaturedItems: boolean;
}

const sortOptions = [
    { title: 'Name', value: '' },
    { title: 'Price', value: 'price' },
    { title: 'Area', value: 'area' }
];

type StateData = {
    currentView: string;
};

const initialState: UsedListingPageState = {
    keywords: '',
    buildingType: undefined,
    location: undefined,
    areaMin: 0,
    areaMax: null,
    hasRestrooms: false,
    canLoadMore: false,
    isLoading: false,
    items: [],
    lastFilter: undefined,
    totalItems: 0,
    searchTrigger: 0,
    currentView: 'grid',
    sortByField: undefined,
    isLocationMissing: false,
    hasFeaturedItems: false
}

const getFilterFromSession = (): SearchIn => {

    var sessionItemData = window.sessionStorage.getItem('bdg_used_listing_filter');

    if (sessionItemData)
        return JSON.parse(sessionItemData);

    return null;
}

const getStateDataFromSession = (): StateData => {
    var sessionItemData = window.sessionStorage.getItem('bdg_used_listing_state');

    if (sessionItemData)
        return JSON.parse(sessionItemData);

    return null;
}

const getUrlVars = (paramName) => {

    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(paramName);
}


const UsedListingPage = (props: Props) => {

    const getInitialState = () => {

        let result = initialState;

        if ((window.location.search || '').length > 3) {

            // keywords
            result.keywords = getUrlVars('q') || '';

            // building title
            var buildingtitle = getUrlVars('buildingtype') || '';
            if (buildingtitle.length > 0) {
                var lookupItem = props.buildingTypes.find(x => x.title.toLowerCase() == buildingtitle.toLowerCase());
                if (lookupItem)
                    result.buildingType = lookupItem;
            }

            // location
            var locationtitle = getUrlVars('loc') || '';
            if (locationtitle.length > 0) {
                var lookupItem = props.locations.find(x => x.title.toLowerCase() == locationtitle.toLowerCase());
                if (lookupItem)
                    result.location = lookupItem;
            }

            // restroom
            result.hasRestrooms = getUrlVars('restroom') == "1";

            // area min / max
            {
                result.areaMin = (getUrlVars('areamin') || 0) as number;
                result.areaMax = (getUrlVars('areamax') || 0) as number;
            }

            // sort
            var sorttitle = getUrlVars('sort') || '';
            if (sorttitle.length > 0) {
                var lookupItem = sortOptions.find(x => x.title.toLowerCase() == sorttitle.toLowerCase());
                if (lookupItem)
                    result.sortByField = lookupItem;
            }


        } else {
            let sessionFilter = getFilterFromSession();
            if (sessionFilter) {
                result.keywords = sessionFilter.keywords;
                result.buildingType = props.buildingTypes
                    .find(x => x.value == sessionFilter.buildingType && sessionFilter.buildingType.length > 0);
                result.areaMax = sessionFilter.areaMax;
                result.areaMin = sessionFilter.areaMin;
                result.hasRestrooms = sessionFilter.hasRestrooms;
                result.location = props.locations
                    .find(x => x.value == sessionFilter.location && sessionFilter.location.length > 0);

                //result.isLocationMissing = (!result.location || !result.location.value)
                result.sortByField = sortOptions.find(x => x.value == sessionFilter.sortByField);
            }

            let sessionState = getStateDataFromSession();
            if (sessionState) {
                result.currentView = sessionState.currentView;
            }
        }        

        return result;
    };

    const [state, setState] = useReducer(
        (prevState: UsedListingPageState, newState: Partial<UsedListingPageState>) => ({ ...prevState, ...newState }),
        getInitialState()
    );

    const search = async () => {

        const lastFilter: SearchIn = {
            keywords: state.keywords,
            buildingType: state.buildingType ? state.buildingType.value : '',
            location: state.location ? state.location.value : '',
            hasRestrooms: state.hasRestrooms,
            areaMin: state.areaMin,
            areaMax: state.areaMax > 0 ? state.areaMax : null,
            sortByField: state.sortByField ? state.sortByField.value : '',
            culture: props.culture
        };

        rememberFilterToSession(lastFilter);        

        setState({
            isLoading: true,
            lastFilter: lastFilter
        });

        //  update url
        {

            let paramsObj = {};
            if (state.keywords.length > 0) {
                paramsObj = {
                    ...{ q: state.keywords },
                    ...paramsObj
                };
            }

            if (state.buildingType) {
                paramsObj = {
                    ...{ buildingtype: state.buildingType.title },
                    ...paramsObj
                };
            }

            if (state.location) {
                paramsObj = {
                    ...{ loc: state.location.title },
                    ...paramsObj
                };
            }

            paramsObj = {
                ...{
                    restroom: state.hasRestrooms ? "1" : "0",
                    areamin: state.areaMin,
                    areamax: state.areaMax
                },
                ...paramsObj
            };

            if (state.sortByField) {
                paramsObj = {
                    ...{ sort: state.sortByField.title },
                    ...paramsObj
                };
            }

            let urlParams = '?' + new URLSearchParams(paramsObj).toString();

            window.history.pushState({}, '', urlParams);
        }

        const result = await UsedListingService.search(lastFilter, PAGE_SIZE, 0);

        if (!result.hasErrors) {
            setState({
                items: result.value.items,
                totalItems: result.value.totalItems,
                isLoading: false,
                canLoadMore: result.value.totalItems > result.value.items.length,
                hasFeaturedItems: result.value.items.find(x => x.isFeatured) != undefined
            })
        }
    }

    const loadMore = async () => {

        setState({
            isLoading: true
        });

        const result = await UsedListingService.search(state.lastFilter, PAGE_SIZE, state.items.length);

        if (!result.hasErrors) {

            const newItemsSet = state.items.concat(result.value.items);

            setState({
                items: newItemsSet,
                totalItems: result.value.totalItems,
                isLoading: false,
                canLoadMore: result.value.totalItems > newItemsSet.length
            })
        }

    }

    const rememberFilterToSession = (filter: SearchIn) => {
        window.sessionStorage.setItem('bdg_used_listing_filter', JSON.stringify(filter));
    }

    const rememberStateDataToSession = (data: StateData)=> {
        window.sessionStorage.setItem('bdg_used_listing_state', JSON.stringify(data));
    }

    useEffect(() => {
        search();
    }, [state.sortByField])

    useEffect(() => {
        rememberStateDataToSession({
            currentView: state.currentView
        });
    }, [state.currentView])

    useEffect(() => {
        search();
    }, []);

    // Triggers after change in state of any of the search filters.
    useEffect(() => {
        if (!props.locations || (state.location && state.location.value)) { // Only do search if location has a value.
            search();
        }
    }, [state.location, state.buildingType, state.areaMax, state.areaMin, state.hasRestrooms]);

    const formatNumber = (value, decimals = 0) => {
        return (parseFloat(value) || 0).toFixed(decimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }

    const sortHandler = <UncontrolledDropdown className="d-inline-flex align-items-center sortby-dropdown">
        <DropdownToggle className="btn-dropdown-sortby">
            Sort by: {state.sortByField ? state.sortByField.title : 'Name'}
        </DropdownToggle>
        <DropdownMenu>
            {sortOptions.map(x => <DropdownItem key={x.value} onClick={() => { setState({ sortByField: x }) }} {...{ active: state.sortByField && (x.value == state.sortByField.value) }}>{x.title}</DropdownItem>)}
        </DropdownMenu>
    </UncontrolledDropdown>

    const viewHandler = <ul className="view-mode-toggler">
        <li className={("view-mode " + (state.currentView === 'grid' ? 'active' : ''))} id="btnGridView">
            <a href="#" title="Grid View" aria-label="Grid View" onClick={(e) => { e.preventDefault(); setState({ currentView: 'grid' }); }}>
                <i className="icon-grid-view"></i>
                <span className="d-block d-sm-none">Grid View</span>
            </a>
        </li>
        <li className={("view-mode " + (state.currentView === 'list' ? 'active' : ''))} id="btnListView">
            <a href="#" title="List View" aria-label="List View" onClick={(e) => { e.preventDefault(); setState({ currentView: 'list' }); }}>
                <i className="icon-list-view"></i>
                <span className="d-block d-sm-none">List View</span>
            </a>
        </li>
    </ul>

    return (
        <>
            <div className="container mb-3">
                <div className="row">
                    <div className="col">
                        <form className="row align-items-end listing-filters">
                            {props.locations && <div className="col-lg-auto col-sm-6 pe-0 mb-3">
                                <div className="form-group mb-0">
                                    <label>Locations <span className="required"> *</span></label>
                                    <UncontrolledDropdown>
                                        <DropdownToggle>
                                            {state.location ? state.location.title : 'All locations'}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {/*
                                            {state.location
                                                && <DropdownItem onClick={() => { setState({ location: undefined }) }}>All locations</DropdownItem>}
                                            */}

                                            {props.locations && props.locations.map(x => <DropdownItem key={x.value} onClick={() => {
                                                setState({ location: x, isLocationMissing: false });
                                            }} {...{ active: state.location && (x.value == state.location.value) }}>{x.title}</DropdownItem>)}

                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                            }
                            <div className="col-lg-auto col-sm-6 pe-0 mb-3">
                                <div className="form-group mb-0">
                                    <label>Building Type</label>
                                    <UncontrolledDropdown>
                                        <DropdownToggle>
                                            {state.buildingType ? state.buildingType.title : 'All building types'}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {state.buildingType
                                                && <DropdownItem onClick={() => { setState({ buildingType: undefined }) }}>All building types</DropdownItem>}

                                            {props.buildingTypes.map(x => <DropdownItem key={x.value} onClick={() => {
                                                setState({ buildingType: x });
                                                if (!state.location || !state.location.value) {
                                                    setState({ isLocationMissing: true });
                                                }
                                            }} {...{ active: state.buildingType && (x.value == state.buildingType.value) }}>{x.title}</DropdownItem>)}

                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                            <div className="col-md-auto col-sm-auto col-xs-auto pe-0 mb-3">
                                <div><label>Building Size sq. ft. </label></div>
                                <div className="d-inline-flex align-items-center">
                                    <div className="form-group mb-0">
                                        <input type="number" onChange={(e) => {
                                            setState({ areaMin: Number.parseFloat(e.target.value) });
                                            if (!state.location || !state.location.value) {
                                                setState({ isLocationMissing: true });
                                            }
                                        }} placeholder="Min" min="0" value={state.areaMin} className="form-control" aria-label="Minimum Building Size sq. ft." />
                                    </div>
                                    <span className="px-2">to</span>
                                    <div className="form-group mb-0">
                                        <input type="number" onChange={(e) => {
                                            setState({ areaMax: Number.parseFloat(e.target.value) });
                                            if (!state.location || !state.location.value) {
                                                setState({ isLocationMissing: true });
                                            }
                                        }} placeholder="Max" min="0" value={state.areaMax} className="form-control" aria-label="Maximum Building Size sq. ft." />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-auto col-sm-auto pe-sm-4 col-xs-auto pe-0 mb-3">
                                <div className="form-check">
                                    <input id="hasRestroom" type="checkbox" onChange={(e) => {
                                        setState({ hasRestrooms: e.target.checked });
                                        if (!state.location || !state.location.value) {
                                            setState({ isLocationMissing: true });
                                        }
                                    }} checked={state.hasRestrooms} value="true" className="form-check-input" />
                                    <label htmlFor="hasRestroom" className="form-check-label d-inline-flex align-items-center">Restroom Available</label>
                                </div>
                            </div>

                            {/*
                            <div className="col-auto col-xs-12 mb-3 pe-0">
                                <div className="form-group mb-0" ><button type="button" className="btn btn-primary d-block w-100" onClick={(e) => {
                                    if (state.location && state.location.value) {
                                        search();
                                    } else {
                                        setState({ isLocationMissing: true });
                                    }
                                }}>Search</button></div>
                            </div>
                            */}

                        </form>
                        {props.locations && state.isLocationMissing && <div className="required-container mt-n2"><span className="required-message">Please select a <b>location</b> to filter</span></div>}
                    </div>
                </div>
            </div>

            <div className="bg-grey pb-4 py-4">
                <div className="container">
                    <div className="row">
                        <div className="col d-flex justify-content-between">
                            {sortHandler}
                            {viewHandler}
                        </div>
                    </div>
                    <InfiniteScroll
                        pageStart={0}
                        loadMore={loadMore}
                        hasMore={state.canLoadMore && !state.isLoading}
                        useWindow={true}
                        className={("row row-cols-1" + (state.currentView === 'grid' ? ' row-cols-sm-2 row-cols-md-3' : '') + (state.hasFeaturedItems ? " mt-3": ''))}
                    >
                        {state.items.map(item => {

                            return <div className="col" key={item.nodeId}>
                                <a className={("card w-100 mb-4 " + (state.currentView === 'list' ? 'list-item' : '') + (item.isFeatured ? " is-featured" : ""))} href={item.url}>
                                    {item.isFeatured && <span className="featured-label">Special Pricing</span>}
                                    <div className="card-top-icon">
                                        <div onClick={(e) => {
                                            e.preventDefault();
                                            var el = jQuery(e.target);
                                            var documentId = el.data('documentid');
                                            var isFavorite = el.data('isfavorite');

                                            if (isFavorite) {
                                                var jqxhr = jQuery.get("/api/favorites/remove/" + documentId, function (data) {
                                                    //
                                                })
                                                    .done(function (data) {
                                                        el.removeClass('selected').data('isfavorite', false);
                                                        jQuery('.my-favorites-star').text(data.totalFavorites);
                                                    })
                                                    .fail(function (ex) {
                                                        console.log(ex);
                                                        // Handle Failure
                                                    });
                                            } else {
                                                var jqxhr = jQuery.get("/api/favorites/add/" + documentId, function (data) {
                                                    //
                                                })
                                                    .done(function (data) {
                                                        el.addClass('selected').data('isfavorite', true);
                                                        var favAlerter = new Bootstrap.Toast(document.getElementById('favorites-alerter'), null)
                                                        favAlerter.show();
                                                        jQuery('#favorites-alerter').find('li').text(data.name);
                                                        jQuery('.my-favorites-star').removeClass('d-none').text(data.totalFavorites);
                                                    })
                                                    .fail(function (ex) {
                                                        console.log(ex);
                                                        // Handle Failure
                                                    });
                                            }
                                            return false;
                                        }} className={("add-to-favorites " + (item.isFavorite ? 'selected' : '') + " favorites-page-card ")} data-documentid={item.documentID} data-isfavorite={item.isFavorite}></div>
                                    </div>
                                    {item.thumbnail && <div className="image-container" style={{ backgroundImage: "url('" + item.thumbnail + "')" }} ></div>}
                                    {item.thumbnail && <img className="card-img-top" src={item.thumbnail} alt={item.thumbnailTitle} />}
                                    <div className="card-body d-flex flex-column">
                                        {item.area && <div className="type-pill d-inline-flex align-items-center">{item.area} sq. ft.</div>}
                                        <h5 className="card-title" dangerouslySetInnerHTML={{ __html: item.title }}></h5>
                                        <div className="abstract">{item.abstract}</div>
                                        <div className="mt-auto card-bottom d-flex">
                                            {!!item.price && <div className="price">${formatNumber(item.price, 2)}</div>}
                                            {item.unitId && <div className="unit-id">{item.unitId}</div>}
                                        </div>
                                    </div>
                                </a>
                            </div>
                        })}

                    </InfiniteScroll>
                    {!state.isLoading && state.items.length == 0 && <div className="listing-no-items-found">
                        Sorry.  There are no buildings matching your search criteria.
                    </div>}
                    <div className="text-center" style={{
                        marginTop: "-12px",
                        height: "45px"
                    }}>
                        {state.isLoading &&
                            <Spinner color="primary" />
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default UsedListingPage;
